export default __webpack_public_path__ + "static/media/element_89.d718e427.webp";